import React from "react";
import RadioButton from "../../../../blocks/filters/RadioButton";
import classNames from "classnames";
import { debounce } from "lodash";
import { observer, inject } from "mobx-react";

@inject("organizationWebinarCreate")
export default class QuizQuestion extends React.Component {
  constructor(props) {
    super(props);
    this.debounceValidateTab = debounce(this.validateTab, 500);
  }

  state = {
    activeTab: 0,
    quizQuestions: [],
    quizValidation: [],
    radiobuttonOne: null,
    radiobuttonTwo: null,
    quizCount: 0,
  };

  componentDidMount() {
    const questions = this.props.organizationWebinarCreate.modules[this.props.moduleIndex]
      .questions_attributes;
    if (questions.length) {
      this.setState(
        {
          ...this.state,
          quizQuestions: [...questions],
          quizValidation: [...Array(questions.length).fill().map(() => ({...{}}))],
          quizCount: questions.length,
        },
        this.radioValue
      );
    }
  }

  switchActiveTab = e => {
    const tabNumber = Number(e.target.innerText) - 1;
    this.setState(
      {
        activeTab: tabNumber
      },
      () => {
        this.outputText;
        this.radioValue();
      }
    );
  };

  validateTab = idx => {
    const newArray = Object.assign([], this.state.quizValidation);
    const isText = this.state.quizQuestions[idx].text;
    const isAnswer = this.state.quizQuestions[idx].correct;
    if (isAnswer !== undefined && isText !== undefined && isText.length > 0) {
      newArray[idx].status = "checked";
      this.setState(
        {
          quizValidation: newArray
        },
        this.saveQuizToStore(idx)
      );
    }
    if (isAnswer !== undefined && isText !== undefined && isText.length === 0) {
      newArray[idx].status = "error";
      this.setState({
        quizValidation: newArray
      });
    }
  };

  saveQuizToStore = idx => {
    let index = this.props.moduleIndex;
    let q_index = idx;
    let data = this.state.quizQuestions[q_index];
    this.props.organizationWebinarCreate.setQuiz(index, q_index, data);
  };

  handleInput = e => {
    const idx = this.state.activeTab;
    const text = e.target.value;
    this.saveText(idx, text);
  };

  saveText = (idx, text) => {
    const newArray = Object.assign([], this.state.quizQuestions);
    newArray[idx].text = text;
    this.setState(
      {
        quizQuestions: newArray
      },
      this.debounceValidateTab(idx)
    );
  };

  outputText = () => {
    const idx = this.state.activeTab;
    const output = this.state.quizQuestions[idx] ? this.state.quizQuestions[idx].text : '';
    if (output) {
      return output;
    }
    return "";
  };

  handleInputRadio = data => {
    const idx = this.state.activeTab;
    const setter = data.name;
    this.setAnswer(idx, setter);
  };

  handleQuizCount = data => {
    let index = this.props.moduleIndex;
    const quizCount = Number(data.name);
    const quizQuestions = [...Array(quizCount).fill().map(() => ({...{}}))];
    const quizValidation = [...Array(quizCount).fill().map(() => ({...{}}))];
    this.setState({
      quizCount,
      quizQuestions,
      quizValidation,
    });
    this.props.organizationWebinarCreate.setQuizCount(index, quizCount);
  };

  setAnswer = (idx, setter) => {
    let newArray = Object.assign([], this.state.quizQuestions);
    if (setter === "q_true") {
      newArray[idx].correct = true;
      this.setState(
        {
          quizQuestions: newArray,
          radiobuttonOne: true,
          radiobuttonTwo: false
        },
        this.debounceValidateTab(idx)
      );
    } else if(setter === "q_false") {
      newArray[idx].correct = false;
      this.setState(
        {
          quizQuestions: newArray,
          radiobuttonOne: false,
          radiobuttonTwo: true
        },
        this.debounceValidateTab(idx)
      );
    } else {
      newArray[idx].correct = null;
      this.setState(
        {
          quizQuestions: newArray,
          radiobuttonOne: null,
          radiobuttonTwo: null
        },
        this.debounceValidateTab(idx)
      );
    }
  };

  radioValue = () => {
    if (!Object.keys(this.state.quizQuestions[this.state.activeTab]).length) {
      this.setState({
        radiobuttonOne: null,
        radiobuttonTwo: null
      });
    } else {
      if (this.state.quizQuestions[this.state.activeTab].correct) {
        this.setState({
          radiobuttonOne: true,
          radiobuttonTwo: false
        });
      } else if(this.state.quizQuestions[this.state.activeTab].correct === undefined) {
        this.setState({
          radiobuttonOne: null,
          radiobuttonTwo: null
        });
      } else {
        this.setState({
          radiobuttonOne: false,
          radiobuttonTwo: true
        });
      }
    }
  };

  render() {
    const index = this.props.moduleIndex;
    return (
      <div className="quiz-wrapper">
        <div className="col-12 quiz-details-wrapper">
          <p>Please indicate do you want the quiz for this module to be:</p>
          <div className="row">
            <div className="quiz-radiogroup">
              <RadioButton
                id={`one_quiz_count_${index}`}
                name="1"
                label="1"
                type="this_quiz_count"
                checked={this.state.quizCount === 1}
                handleChange={this.handleQuizCount}
              />
              <RadioButton
                id={`three_quiz_count_${index}`}
                name="3"
                label="3"
                type="this_quiz_count"
                checked={this.state.quizCount === 3}
                handleChange={this.handleQuizCount}
              />
              <RadioButton
                id={`five_quiz_count_${index}`}
                name="5"
                label="5"
                type="this_quiz_count"
                checked={this.state.quizCount === 5}
                handleChange={this.handleQuizCount}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="quiz-selector-wrapper">
              {this.state.quizQuestions.map((quizQuestion, index) => {
                return (
                  <span
                    key={index}
                    onClick={this.switchActiveTab}
                    className={classNames(
                      "btn-selectQuiz",
                      {
                        active: this.state.activeTab == index
                      },
                      { error: this.state.quizValidation[index].status === "error" },
                      { checked: this.state.quizValidation[index].status === "checked" }
                    )}
                  >
                    {index + 1}
                  </span>
                );
              })}
              {/* <span
                onClick={this.switchActiveTab}
                className={classNames(
                  "btn-selectQuiz",
                  {
                    active: this.state.activeTab == 0
                  },
                  { error: this.state.quizValidation[0].status === "error" },
                  { checked: this.state.quizValidation[0].status === "checked" }
                )}
              >
                1
              </span>
              <span
                onClick={this.switchActiveTab}
                className={classNames(
                  "btn-selectQuiz",
                  {
                    active: this.state.activeTab == 1
                  },
                  { error: this.state.quizValidation[1].status === "error" },
                  { checked: this.state.quizValidation[1].status === "checked" }
                )}
              >
                2
              </span>
              <span
                onClick={this.switchActiveTab}
                className={classNames(
                  "btn-selectQuiz",
                  {
                    active: this.state.activeTab == 2
                  },
                  { error: this.state.quizValidation[2].status === "error" },
                  { checked: this.state.quizValidation[2].status === "checked" }
                )}
              >
                3
              </span>
              <span
                onClick={this.switchActiveTab}
                className={classNames(
                  "btn-selectQuiz",
                  {
                    active: this.state.activeTab == 3
                  },
                  { error: this.state.quizValidation[3].status === "error" },
                  { checked: this.state.quizValidation[3].status === "checked" }
                )}
              >
                4
              </span>
              <span
                onClick={this.switchActiveTab}
                className={classNames(
                  "btn-selectQuiz",
                  {
                    active: this.state.activeTab == 4
                  },
                  { error: this.state.quizValidation[4].status === "error" },
                  { checked: this.state.quizValidation[4].status === "checked" }
                )}
              >
                5
              </span> */}
            </div>
          </div>
        </div>
        {this.state.quizCount > 0 && (
          <div className="row">
            <div className="col-12 quiz-details-wrapper">
              <p>Question Details</p>
              <textarea
                onChange={this.handleInput}
                value={this.outputText()}
                name="question"
                className="quiz-textarea"
                cols="30"
                rows="7"
                placeholder="Type in your question and the correct answer (i.e. either True or False) below. You must specify 5 True / False questions for the quiz."
              />
              <div className="quiz-radiogroup">
                <RadioButton
                  key={this.props.moduleIndex + 1}
                  id={`${this.props.moduleIndex}-q_true`}
                  name="q_true"
                  label="True"
                  type="this_answer"
                  checked={this.state.radiobuttonOne}
                  handleChange={this.handleInputRadio}
                />
                <RadioButton
                  key={this.props.moduleIndex + 100}
                  id={`${this.props.moduleIndex}-q_false`}
                  name="q_false"
                  label="False"
                  type="this_answer"
                  checked={this.state.radiobuttonTwo}
                  handleChange={this.handleInputRadio}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/create_organization_webinar/create_module/create_question/QuizQuestion.jsx